import { useContext, createContext, ReactNode, useState, useCallback, useMemo } from 'react';
import { useNotificationModal } from '@room-match/shared-ui-components';

type RepresentativesModalContexProps = {
  handleOpen: VoidFunction;
  handleSetMessage: (header: string, message: string, cta: string) => void;
};

export const RepresentativesModalContext = createContext<RepresentativesModalContexProps>({
  handleOpen: () => {},
  handleSetMessage: () => {},
});

export const RepresentativesModalProvider = ({ children }: { children: ReactNode }) => {
  const {
    isOpen,
    handleOpen: handleOpenError,
    handleSetMessage: handleSetErrorMessage,
    NotificationModal,
  } = useNotificationModal({
    type: 'error',
  });

  const MemoizedNotifcicationModal = useMemo(() => <NotificationModal />, [isOpen]);

  const handleSetMessage = useCallback((header: string, message: string, cta: string) => {
    handleSetErrorMessage(header, message, cta);
  }, []);

  const handleOpen = useCallback(() => {
    handleOpenError();
  }, []);

  const value = useMemo(
    () => ({
      handleOpen,
      handleSetMessage,
    }),
    [],
  );

  return (
    <RepresentativesModalContext.Provider value={value}>
      {isOpen ? MemoizedNotifcicationModal : null}
      {children}
    </RepresentativesModalContext.Provider>
  );
};

export const useRepresentativesModal = () => {
  const context = useContext(RepresentativesModalContext);

  if (context === undefined) {
    throw new Error('You need context for this component');
  }

  return context;
};
